import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import IconPlus from 'assets/icons/plus.svg'
import usePaystubItemCalculationTriggering from 'components/blocks/forms/FormPayStub/FieldsPayStubEarningsStatement/usePaystubItemCalculationTriggering'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubEarningsStatementNew.module.scss'
import ItemEarningsList from './ItemEarningsList'
const cx = cn.bind(s)

interface IItemEarningsBlockProps {
	index: number
}

const ItemEarningsBlock: FC<IItemEarningsBlockProps> = ({index}) => {
	const {items, isAutoCalculation, addEarningsItem} = usePayStubStore()

	const item = items[index]
	const [cancel] = usePaystubItemCalculationTriggering(item)
	return (
		<div className={cx('earnings')}>
			<div className={cx('earnings__fields')}>
				<div className={cx('earnings__field', 'earnings__field--heading')}>
					<span className={cx('label')}>Earnings</span>
				</div>
				<div className={cx('earnings__field')}>
					<span className={cx('label')}>Rate</span>
				</div>
				<div className={cx('earnings__field')}>
					<span className={cx('label')}>Hours</span>
				</div>
				<div className={cx('earnings__field')}>
					<span className={cx('label')}>Total</span>
				</div>
				<div className={cx('earnings__field')}>
					<span className={cx('label')}>Ytd total</span>
				</div>
			</div>

			<ItemEarningsList store={item} topCancel={cancel} />

			{index === 0 && (
				<button
					className={cx('btn', 'btn--add')}
					onClick={addEarningsItem}
					type="button"
					title="Add earnings">
					<IconPlus className={cx('btn__plus')} /> <span>Add earnings</span>
				</button>
			)}

			<div className={cx('earnings__fields', 'gross-pay')}>
				<div className={cx('earnings__field', 'gross-pay__field')}>
					<span className={cx('label')}>Gross pay</span>
				</div>
				<div className={cx('earnings__field', 'gross-pay__field')}>
					<MobxTextInput
						className={cx('ta-right')}
						placeholder="0.00"
						store={items[index]}
						name="grossPayTotal"
						type="text"
						isNumber
						shouldHandleOldValue
						isFormatText
						readOnly={isAutoCalculation}
						variant="new"
					/>
				</div>
				<div className={cx('earnings__field', 'gross-pay__field')}>
					<MobxTextInput
						className={cx('ta-right')}
						placeholder="0.00"
						store={items[index]}
						name="grossPayYTDTotal"
						type="text"
						isNumber
						shouldHandleOldValue
						isFormatText
						readOnly={isAutoCalculation}
						variant="new"
					/>
				</div>
			</div>
		</div>
	)
}

ItemEarningsBlock.displayName = 'ItemEarningsBlock'

export default observer(ItemEarningsBlock)
